module.exports = __webpack_public_path__ + "static/media/4.93c6f661.jpg";